import * as BlogPost1 from '../_posts/fordelarna-med-att-delta-i-styrelsen-for-din-bostadsrattsforening'
import * as BlogPost2 from '../_posts/varfor-delning-av-losenord-ar-farligt-for-din-bostadsrattsforening'
import * as BlogPost3 from '../_posts/spara-pa-elen-7-smarta-tips'
import * as BlogPost4 from '../_posts/en-djupdykning-i-rorliga-rantor-det-forandrade-lanebeteendet'
import * as BlogPost5 from '../_posts/sakra-ditt-forrad-mot-inbrott'
import * as BlogPost6 from '../_posts/andrahandsuthyrning-i-bostadsrattsforeningar'
import * as BlogPost7 from '../_posts/maximera-varde-av-bostadsratt'
import * as BlogPost8 from '../_posts/bostadsrattsforeningar-och-gemenskap'
import * as BlogPost9 from '../_posts/sa-hanterar-du-stromavbrott'
import * as BlogPost10 from '../_posts/ordna-den-perfekta-kraftskivan'
import * as BlogPost11 from '../_posts/skapa-gronska-pa-balkongen'
import * as BlogPost12 from '../_posts/svalka-ditt-hem-i-sommarvarmen'
import * as BlogPost13 from '../_posts/roller-och-ansvar-i-styrelsen'
import * as BlogPost14 from '../_posts/brandforebyggande-tips-i-lagenheten'
import * as BlogPost15 from '../_posts/sno-istappar-ansvar-for-bostadsrattsforening'
import { BlogPost } from '../OverviewEntry'

export const entries: BlogPost[] = [
  BlogPost15.meta,
  BlogPost14.meta,
  BlogPost13.meta,
  BlogPost12.meta,
  BlogPost11.meta,
  BlogPost10.meta,
  BlogPost9.meta,
  BlogPost8.meta,
  BlogPost7.meta,
  BlogPost6.meta,
  BlogPost5.meta,
  BlogPost4.meta,
  BlogPost3.meta,
  BlogPost2.meta,
  BlogPost1.meta,
].sort((a, b) => b.publishedAt.getTime() - a.publishedAt.getTime())
